var divider_viewer_rtlignore_default = {
  "divider-container": "AxNlI",
  "divider-container--double": "LjzNd",
  "divider": "_2DBzA",
  "divider--single": "a-2E-",
  "divider--double": "N7zfV",
  "divider--dashed": "ieBS4",
  "divider--dotted": "CacHd",
  "divider--small": "kS-mS",
  "divider--medium": "HLqec",
  "divider--large": "I4Fhz",
  "divider--left": "pklho",
  "divider--center": "fRTmQ",
  "divider--right": "no91s",
  "svgFixerContainer": "_2-lZr",
  "emptyChar": "o5Mft"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
